import styled from 'styled-components'
import { Select } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntSelectStyled = styled(Select)`
  &&& {
    &.ant-select-single.ant-select-show-arrow .ant-select-selector {
      padding-right: 50px;
    }

    .ant-select-arrow {
      color: ${greys.light4};
      width: 50px;
      height: 100%;
      background-color: ${props => props.theme.colors.color1.bg};
      margin: 0;
      padding: 0;
      inset-inline-end: 0;
      top: 0;
      transform: none;
      display: flex;
      align-items: center;
      justify-content: center;
      border-start-end-radius: inherit;
      border-end-end-radius: inherit;
    }

    .ant-select-arrow .anticon,
    .ant-select-arrow .ant-select-suffix {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled),
    .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
      background-color: ${props => props.theme.colors.color1.bg};
      color: ${greys.light4};
    }

    .ant-select-dropdown-menu-item-selected,
    .ant-select-dropdown-menu-item-selected:hover {
      background-color: ${props => props.theme.colors.color1.bg};
      color: ${greys.light4};
    }
  }
`

export default AntSelectStyled
